import axios from 'axios'

export default {
    data() {
        return {
            user_id: '',
            user_name: '',
            account_id: '',
            cart: {}
        }
    },
    getBaseURL() {
        return axios.defaults.baseURL;
    },
    getApplicationVersion() {
        return axios.get('/Lookup/GetApplicationVersion')
            .then(response => {
                //console.log(response);
                return response.data;
            })
            .catch(err => console.warn(err));
    },
    getCustomDefault(default_name, default_value) {
        return axios.get('/Lookup/GetCustomDefault', {
            params: {
                name: default_name
            }
        })
        .then(response => {
            //console.log(default_name);
            //console.log(response);
            if (response == "") return default_value;
            response = JSON.parse(response.data);
            var value = decodeURIComponent(response.value)
            if (value == "") {
                value = default_value;
            }
            return value;
        })
        .catch(err => { console.warn(err); return default_value; });
    },
    searchLandRecords(user_id, ppin, year, parcel, name, unredeemed, kiosk) {
        return axios.get('/Home/SearchLandRecords', {
            params: {
                user_id: user_id,
                ppin: ppin,
                year: year,
                parcel: parcel,
                name: name,
                unredeemed: unredeemed,
                kiosk: kiosk
            }
        })
        .then(response => {
            //console.log(response);
            return response.data;
        })
        .catch(err => { console.warn(err); return null; });
    },
    exportResults(user_id, ppin, year, parcel, name, unredeemed, kiosk, type) {
        var url = this.getBaseURL();
        url += "Home/SearchLandRecords?";
        url += "user_id=" + user_id;
        url += "&ppin=" + ppin;
        url += "&year=" + year;
        url += "&parcel=" + parcel;
        url += "&name=" + name;
        url += "&unredeemed=" + unredeemed;
        url += "&kiosk=" + kiosk;
        url += "&export=" + type;
        window.open(url);
    },
    loadRedemptionCase(gin, tax_year) {
        return axios.get('/Home/LoadRedemptionCase', {
            params: {
                gin: gin,
                tax_year: tax_year
            }
        })
        .then(response => {
            //console.log(response);
            return response.data;
        })
        .catch(err => { console.warn(err); return null; });
    },
    getAvailableYears(gin) {
        return axios.get('/Home/GetAvailableYears', {
            params: {
                gin: gin
            }
        })
        .then(response => {
            //console.log(response);
            return response.data;
        })
        .catch(err => { console.warn(err); return null; });
    },
    checkout(gin, first_name, last_name, address, city, state, zip, phone, email, arrYears, reference) {
        return axios.get('/Account/Checkout', {
            params: {
                gin: gin,
                first_name: first_name,
                last_name: last_name,
                address: address,
                city: city,
                state: state,
                zip: zip,
                phone: phone,
                email: email,
                arrYears: JSON.stringify(arrYears),
                reference: reference
            }
        })
        .then(response => {
            //console.log(response);
            return response.data;
        })
        .catch(err => { console.warn(err); return null; });
    },
    getApplicationVersion() {
        return axios.get('/Lookup/GetApplicationVersion')
            .then(response => {
                //console.log(response);
                return response.data;
            })
            .catch(err => console.warn(err));
    },
    getCustomerInfo() {
        return axios.get('/Lookup/GetCustomerInfo')
        .then(response => {
            //console.log(response);
            return response.data;
        })
        .catch(err => console.warn(err));
    },
    getTemplateText(template_name) {
        return axios.get('/Lookup/GetBlobTextTemplate', {
            params: {
                template_name: template_name
            }
        })
        .then(response => {
            //console.log(response);
            return response.data;
        })
        .catch(err => console.warn(err));
    },
    getCreditCardMerchant() {
        return axios.get('/Lookup/GetCreditCardMerchant')
            .then(response => {
                //console.log(response);
                response = JSON.parse(response.data);
                return response.name;
            })
            .catch(err => console.warn(err));
    },
}